export default {
    data() {
        return {
            state: "",
        }
    },
    methods: {

        changeState(state) {
            this.state = state;
        }
    }
}
